/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// Ensures that the call to action triggered on product_landing_pages/show stays in the viewport while scrolling.
// User doesn't just scroll over deadspace but has constant visibility of the CTA
// Attached to an ID in shared/_call_to_action_plp

var debounce = function debounce(func, wait, immediate) {
  var timeout = undefined;
  return function() {
    var context = this;
    var args = arguments;

    var later = function later() {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  };
};

var applyTimedBlur = function applyTimedBlur() {
  // applies for Timed dialogs only >> Currently CLP (Curated Landing Pages) and Articles
  // applies class to fixed position table header which is outside the blur container
  if ($(".cta-timed-blur").length > 0) {
    $(".cta-timed-blur, .sticky").addClass('blur');
  }

  // Don't forget to add 'hidden' class on your timed dialog!
  return $("#cta-timed-dialog").removeClass("js-dn");
};

var applyTimedCallToAction = function applyTimedCallToAction() {
  var currentTime = new Date().getTime();
  // This fragment uses localStorage to track the visited time.
  // If the user has visited the page before, applies the CTA immediately.
  // Otherwise waits 10sec, then applies.
  // TODO: Make timer dynamic.
  try {
    if (localStorage.time) {
      // If 1 minute has passed we apply the blur instantly and reset the
      // local storage time
      if ((currentTime - localStorage.time) >= 60000) {
        applyTimedBlur();
        localStorage.time = currentTime;
      } else {
        setTimeout(applyTimedBlur, 10000);
      }
    } else {
      localStorage.time = currentTime;
      setTimeout(applyTimedBlur, 10000);
    }
  } catch (error) {
    applyTimedBlur();
  }
};

var scrollMe = debounce(
  function() {
    var offsetOfCallToAction = $(".cta-wrapper").offset().top;
    var relativePosition = offsetOfCallToAction - $(window).scrollTop();
    // This should be the sum of the member bar + the navigation bar heights really
    var heighFixedItems = 100;
    if (relativePosition < 0) {
      var newTop = heighFixedItems - relativePosition;
      $('.call-to-action').css('top', "".concat(newTop, "px"));
    } else {
      $('.call-to-action').css('top', "");
    }
  },
  50
);

var stopScrollMe = debounce(
  function() {
    // distance from top of footer to top of document
    var footertotop = $("footer").position().top;
    // distance user has scrolled from top, adjusted to take in height of sidebar.
    var scrolltop = $(document).scrollTop();
    // difference between the two
    var difference = scrolltop - footertotop;
    // if user has scrolled further than footer, fix CTA position to % of page height
    // TODO refine the top percentage value
    // Basically this is only here to prevent the CTA from overflowing onto the footer in mobile.
    // As it's leaving the viewport in most circumstances this may not matter too much
    if (difference >= -450) {
      $('.call-to-action').css('top', '50%');
    }
  },
  50
);

$(document).ready(function() {
  // Actions for timed CTAs >> Currently CLP (Curated Landing Pages) and Article
  if ($(".cta-timed-blur, #cta-timed-dialog").length !== 0) { applyTimedCallToAction(); }
  $(".cta-dialog-free-layout .exit").click(function() {
    return $(this).closest(".cta-dialog-free-layout").remove();
  });

  // Vertical CTA scroller
  if ($(".call-to-action:not(.cta-dialog-free-layout)").length !== 0) {
    $(window).scroll(scrollMe);
    // Stop CTA scroller when we reach footer
    return $(window).scroll(stopScrollMe);
  }
});
